import { lazy } from "react";
import Loadable from "app/components/Loadable";

const MailConfigList = Loadable(lazy(() => import("./MailConfigList")));
const MailConfigAdd = Loadable(lazy(() => import("./MailConfigAdd")));

const MailConfigRoutes = [
  { path: "/config/mail-config", element: <MailConfigList /> },
  { path: "/config/mail-config/:mode/:id", element: <MailConfigAdd /> },
];

export default MailConfigRoutes;
